export const LOGIVAN_PHONE = '033131618';
export const LOGIVAN_SOURCE = 'https://logivan.com';
export const APPLOGIVAN_HREF = 'https://app.logivan.com';
export const LOGIVAN_ACCOUNT_NUMBER = '020077155555';
export const DETAIL_DATE_TIME = 'dddd, DD/MM/YYYY, hh:mm a';
